import Merchants from '../../terms/merchants';
import React from 'react';
import Countries from '~/components/countries_enum.ts';
import FetchPolicy from "../../../src/fetchPolicy";

const language = 'es';

const TermsMerchants = ({ markdownData }) => {
    return (
        <Merchants
            markdownData={markdownData}
            country={Countries.PERU}
            language={language}
            widget
        />
    );
};


export async function getServerSideProps({ query, res }) {
    const data = await FetchPolicy(language, Countries.PERU, 'pay/merchant', 'terms', query?.branch);
    if (data.redirectUrl !== null) {
        console.error('FetchPolicy problem, redirected to Github, terms');
        res.redirect(302, data.redirectUrl);
    }
    return {
        props: {
            markdownData: data,
        },
    };
}

export default TermsMerchants;
